import { OfferCategoryApiClient } from '@fourthwall/services/dist/OfferCategoryApiClient'
import { createQueryHook } from '@fourthwall/utils'

export const useVerticalOfferCategoriesQuery = createQueryHook(
  OfferCategoryApiClient.getVerticalOfferCategories,
  {
    queryKey: ['verticalOfferCategories'],
  },
)
